import { render, staticRenderFns } from "./BotStatusEditor.vue?vue&type=template&id=7195b707&"
import script from "./BotStatusEditor.vue?vue&type=script&lang=js&"
export * from "./BotStatusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports